import React from "react";
import {useTranslation} from "react-i18next";

const RequestsTableHead = () => {
  const {t} = useTranslation();

  return (
    <div className="requests-to-us_head">
      <div className="requests-to-us_head__project">{t("PROJECT")}</div>
      <div className="requests-to-us_head__name">{t("NAME")}</div>
      <div className="requests-to-us_head__column __buyer">{t("BUYER")}</div>
      <div className="requests-to-us_head__column __date">{t("CLOSES_FOR_OFFERS")}</div>
      <div className="requests-to-us_head__response">{t("OUR_RESPONSE")}</div>
    </div>
  );
};

export default RequestsTableHead;
